import { ILabelFieldValue } from "common/form/fields/label/LabelField";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import Layout from "common/form/fields/layout/Layout";
import { BlockView } from "../../common/views/block/BlockView.view";
import { SeparatorView } from "../../common/views/separator/Separator.view";
import StringUtil from "../util/StringUtil";
import { Fragment, FragmentList, FragmentProvider } from "./FragmentProvider";

export interface IFragmentLayoutConfig {
	fragments: string[];
	wrapper: boolean;
	seperator: boolean;
	default: boolean;
	enableTitle?: boolean;
	title?: ILabelFieldValue;
}

export interface IFragmentLayoutRendererProps<T = any> extends IFragmentLayoutConfig {
	regionUuid: string;
	index: number;
	fragmentList: FragmentList<T>;
	props: T;
}

const FragmentLayoutRenderer: React.SFC<IFragmentLayoutRendererProps> = ({regionUuid, index, fragments, wrapper, seperator, fragmentList, props}) => {

	// TODO use a view from core not common. Alow override to be regisered by common, etc.
	const seperatorView = seperator && <SeparatorView key={regionUuid} viewKey={StringUtil.format("%s.separator", regionUuid)} />;

	// const Provider = FragmentProvider.forFragments(regionUuid, fragmentList);
	const elements = <FragmentProvider key={regionUuid + '-' + index} fragmentList={fragmentList} registry={regionUuid} fragments={fragments} fragmentProps={props} separator={seperatorView} />;

	if(wrapper) {
		// TODO use a view from core not common. Alow override to be regisered by common, etc.
		return (
			<BlockView key={regionUuid + '-' + index} viewKey={StringUtil.format("%s.wrapper", regionUuid)}>
				{elements}
			</BlockView>
		);
	}

	return elements;
};

export interface IFragmentLayoutProps<T = any> {
	layout: ILayout<IFragmentLayoutConfig>;
	fragments: FragmentList<T>;
	props: T;
}

export const FragmentLayout: React.SFC<IFragmentLayoutProps> = ({fragments, layout, props}) => (
	<Layout data={layout} renderRegion={(config, index, guid) => (
		<FragmentLayoutRenderer key={guid} {...config } regionUuid={guid} index={index} fragmentList={fragments} props={props} />
	)} />
);

export function getDefaultFragments(layout: ILayout<IFragmentLayoutConfig>) {
	const region = layout && layout.regions && Object.values(layout.regions).find((region) => region.data && region.data.default);
	return region && region.data.fragments || [];
}

export function filterDefaultFragments<T, F extends Fragment<T>>(fragments: FragmentList<T, F>, layout: ILayout<IFragmentLayoutConfig>): F[] {
	const defaults = getDefaultFragments(layout) || [];

	/*return Object.entries(fragments)
		.filter(([k]) => defaults.includes(k))
		.sort(([k]) => defaults.findIndex((f) => f === k))
		.map(([k, v]) => v);*/

	// use map to both sort and filter
	return defaults.map((fragmentId) => fragments[fragmentId]);
}



// WEBPACK FOOTER //
// ./src/core/components/FragmentLayout.tsx